import React from "react";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";

function Surcharge({ appData }) {
  const getPricingName = () => {
    if (appData.qualifiedtype === "tiered") return "Tiered";
    if (appData.qualifiedtype === "surcharge") return "Surcharge";
    if (appData.qualifiedtype === "dual_pricing") return "Dual Pricing";
    if (appData.qualifiedtype === "flat_rate") return "Flat Rate";
    if (appData.qualifiedtype === "ic_plus") return "IC Plus";
  };

  const getPricingDataById = (id) => {
    let pricing = appData.prices.find((price) => price.id === id);
    return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
  };

  return (
    <>
      <ul>
        <li>
          <div>
            <p>Pricing model</p>
            <p>{getPricingName(appData.qualifiedtype)}</p>
          </div>
        </li>
      </ul>

      {/* Surcharge Rates */}
      <div>
        {/* <HeadingWithLine text="Pin-Based Debit" /> */}
        <ul>
          <li>
            <div>
              <p>Surcharge Rate</p>
              <p>{getPricingDataById(35).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Per Transaction</p>
              <p>{getPricingDataById(35).dollars}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Monthly Fee</p>
              <p>{getPricingDataById(17).dollars}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Pin Based Debit */}
      <div>
        <HeadingWithLine text="Pin-Based Debit" />
        <ul>
          <li>
            <div>
              <p>Debit Rate</p>
              <p>{getPricingDataById(5).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Per Transaction</p>
              <p>{getPricingDataById(5).dollars}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Debit Structure */}
      <div>
        <HeadingWithLine text="Debit Structure" />
        <ul>
          <li>
            <div>
              <p>Debit Structure</p>
              <p>{getPricingName(appData.pricing_model)}</p>
            </div>
          </li>
        </ul>
      </div>

      {appData.pricing_model == "tiered" ? (
        <div>
          <ul>
            <li>
              <div>
                <p>Qualified Debit Rate</p>
                <p>{getPricingDataById(39).percent}%</p>
              </div>
            </li>
            <li>
              <div>
                <p>Qualified Txn Fee</p>
                <p>{getPricingDataById(39).dollars}</p>
              </div>
            </li>
            <li>
              <div>
                <p>Mid - Qualified Debit Rate</p>
                <p>{getPricingDataById(40).percent}%</p>
              </div>
            </li>
            <li>
              <div>
                <p>Mid - Qualified Txn Fee</p>
                <p>{getPricingDataById(40).dollars}</p>
              </div>
            </li>
            <li>
              <div>
                <p>Non - Qualified Debit Rate</p>
                <p>{getPricingDataById(41).percent}%</p>
              </div>
            </li>
            <li>
              <div>
                <p>Non - Qualified Txn Fee</p>
                <p>{getPricingDataById(41).dollars}</p>
              </div>
            </li>
          </ul>
        </div>
      ) : (
        <div>
          <ul>
            <li>
              <div>
                <p>IC+ Debit Rate</p>
                <p>{getPricingDataById(39).percent}</p>
              </div>
            </li>
            <li>
              <div>
                <p>IC+ Txn Fee</p>
                <p>{getPricingDataById(39).dollars}%</p>
              </div>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default Surcharge;
